<template>
  <div>
    <pills :filtro="filtro" class="mb-2" />
    <VueApexCharts width="450" :options="data.chartOptions" :series="series" />
  </div>
</template>
<script>
import helpers from "@/common/utils/helpers";
import VueApexCharts from "vue-apexcharts";

import DashboardProponenteService from "@/common/services/dashboards/dashboard_proponente.service.js";
import Pills from "./Pills.vue";

export default {
  components: {
    Pills,
    VueApexCharts,
  },
  data: () => ({
    dados: [],
    filtro: {},
    data: {
      chartOptions: {
        chart: {
          width: 450,
          type: "donut",
        },
        labels: helpers.FaseInovacao.map((item) => item.text),
        legend: {
          position: "bottom",
          customLegendItems: helpers.FaseInovacao.map((item) => item.text),
        },
      },
    },
  }),
  methods: {
    buscar: function (empresaId, grupoNegocio = false, filtro = {}) {
      this.filtro = filtro;
      DashboardProponenteService.projetos(empresaId, grupoNegocio, filtro).then(
        (response) => {
          this.dados = response.data.data;
        }
      );
    },
  },
  mounted() {
    this.buscar();
  },
  computed: {
    total: function () {
      return this.dados.length;
    },
    empresasSelecionada: function () {
      if (!this.$store.state.app.selectedCompanyObj) return null;
      return this.$store.state.app.selectedCompanyObj.id;
    },
    series: function () {
      let value = [];
      helpers.FaseInovacao.map((el) => {
        value.push(
          this.dados.filter((el2) => el2.faseInovacao == el.value).length
        );
      });
      return value;
    },
  },
};
</script>
<style lang="">
</style>